import styled from "@emotion/styled";
import {SyntheticEvent} from "react";

export const TermsTitle = styled.h3`
	display: flex;
	justify-content: center;
	margin: 5px 0 15px;
	font-size: 28px;
	color: #000;
`;
export const TermsText = styled.div`
	font-size: 14px;
	line-height: 24px;
	color: #000;
	margin-bottom: 24px;

	height: auto;
	opacity: 1;
	transition: 0.5s;

	&.invisible {
		height: 0;
		opacity: 0;
		overflow: hidden;
	}

	a {
		color: #2687ff;
	}
`;

export const TermsCheckBoxContainer = styled.div`
	margin: 20px 0 10px;
	height: auto;
	opacity: 1;
	transition: 0.5s;

	&.invisible {
		height: 0;
		opacity: 0;
		overflow: hidden;
	}
`;

export const TermsButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto 20px;
	color: #fff;
	background: #090b0f;

	box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
	max-width: 295px;
	cursor: pointer;
	white-space: nowrap;
	font-size: 18px;
	text-align: center;
	width: 100%;
	height: 40px;
	border-radius: 60px;
	border: 2px solid #090b0f;
	transition: all 0.1s linear;

	&:hover {
		background: transparent;
		border-color: #fff;
		color: #090b0f;
	}

	&:disabled {
		background: grey;
		border: 2px solid grey;
		cursor: not-allowed;

		&:hover {
			background: grey;
			border: 2px solid grey;
			cursor: not-allowed;
			color: #fff;
		}
	}

	&:focus {
		outline: 0;
	}
`;

export interface ITermsModalProps {
	trackActionRules: () => void;
	onPlay: () => void;
	handlerChange?: (e: SyntheticEvent<HTMLInputElement>) => void;
}
